import api from './api';

/** Upcoming Hub calendar events — used by the planning form picker */
export const getUpcomingHubEvents = () =>
  api.get('/hub-events').then(r => r.data);

/** Member's own chosen Hub event activities — used on the dashboard */
export const getMyHubEvents = () =>
  api.get('/hub-events/my-events').then(r => r.data);

/** Real per-event replays, most recent first — each event's own recording. */
export const getEventReplays = () =>
  api.get('/hub-events/replays').then(r => r.data);

/** This week's replay post URL — shown as a card on the dashboard */
export const getReplayPostUrl = () =>
  api.get('/hub-events/replay-url').then(r => r.data);

/** Admin: update the weekly replay post URL */
export const updateReplayPostUrl = (url) =>
  api.put('/hub-events/replay-url', { url }).then(r => r.data);

/** Member preferences: update replay opt-in and timezone */
export const updateMemberPreferences = (prefs) =>
  api.patch('/members/me/preferences', prefs).then(r => r.data);

/** Live GHL tag status for all setting toggles */
export const getMemberGhlTags = () =>
  api.get('/members/me/ghl-tags').then(r => r.data);

/** "Send exercises to me" preferences — real, saved, not operational yet. */
export const getMyActivityPreferences = () =>
  api.get('/members/me/activity-preferences').then(r => r.data.preferences);

export const updateMyActivityPreference = (activityKey, fields) =>
  api.put('/members/me/activity-preferences', { activityKey, ...fields }).then(r => r.data);
